/**
 * @description Neutral pack-sized shell while GET /features/pack-chrome is unresolved (LYN-361)
 *
 * Key features:
 * - Light 272px rail + gray canvas — not LynxPay header / search / footer
 * - Used on /so while the pack flag is in flight
 *
 * @dependencies none
 *
 * @notes Do not import BaseSidebarLayout, AppHeader, or AppFooter.
 */

import React from 'react';

const PackResolvingShell = () => (
  <div className="flex min-h-screen bg-gray-50" data-testid="pack-resolving-shell">
    <aside
      className="hidden lg:block w-[272px] flex-shrink-0 bg-white border-r border-gray-200"
      aria-hidden="true"
    />
    <div className="flex-1 min-w-0" />
  </div>
);

export default PackResolvingShell;
